import {
  IonButton,
  IonButtons,
  IonCard,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonText,
  IonTitle,
  IonToolbar,
  IonSearchbar,
  IonSpinner,
} from "@ionic/react";
import { bagOutline, locationOutline, trashOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserAvatar from "../../../components/UserAvatar";
import {
  setDeselectAll,
  setDeselectUser,
  setPreselectUser,
} from "../../../store/massiveDocumentCreate";
import { selectSelectedUsers } from "../../../store/massiveDocumentCreate/selectors/selectSelectedUsers";
import { selectEnabledUsers } from "../../../store/massiveDocumentCreate/selectors/selectEnabledUsers";
import { useParams } from "react-router-dom";
import { selectFindUserRoleStatus } from "../../../store/massiveDocumentCreate/selectors/selectFindUserRoleStatus";

export const UsersSelected = () => {
  const dispatch = useDispatch();

  const selectedUsers = useSelector(selectSelectedUsers);
  const users = useSelector(selectEnabledUsers);
  const findStatus = useSelector(selectFindUserRoleStatus);

  const [selectedUserSearchText, setSelectedUserSearchText] = useState("");

  const { userId }: { userId: string } = useParams();

  const selectedUser = users.filter((user) => user.user.id == userId);

  useEffect(() => {
    if (selectedUser.length > 0) {
      dispatch(setPreselectUser(selectedUser[0]));
    }
  }, [selectedUser]);

  return (
    <IonCard style={{ height: "75vh", overflow: "auto" }} class="ion-no-margin">
      <IonToolbar color="primary">
        <IonTitle size="small" style={{ fontWeight: 500 }}>
          Seleccionados ({selectedUsers.length})
        </IonTitle>
        {userId != undefined ? null : (
          <IonButtons slot="end">
            {!!selectedUsers.length && (
              <IonButton
                fill="solid"
                color="danger"
                onClick={() => {
                  dispatch(setDeselectAll());
                }}
                size="small"
              >
                <small>Quitar todos</small>
                <IonIcon icon={trashOutline} slot="end" />
              </IonButton>
            )}
          </IonButtons>
        )}
      </IonToolbar>
      {userId != undefined ? null : (
        <IonSearchbar
          value={selectedUserSearchText}
          onIonChange={({ detail: { value = "" } }) => {
            setSelectedUserSearchText(value);
          }}
          debounce={900}
          placeholder="Buscar usuario..."
        />
      )}

      {findStatus === "pending" && userId != undefined && (
        <p className="ion-text-center">
          <IonSpinner />
        </p>
      )}
      {selectedUsers.length === 0 && userId === undefined && (
        <p className="ion-text-center">No hay usuarios seleccionados.</p>
      )}
      {findStatus === "fulfilled" && (
        <IonList>
          {selectedUsers
            .filter(({ user }: any) =>
              user.name?.toLowerCase().includes(selectedUserSearchText.toLowerCase())
            )
            .map((userRoleItem) => (
              <IonItem key={userRoleItem.id}>
                <UserAvatar user={userRoleItem.user}></UserAvatar>
                <IonLabel>
                  <h2 style={{ fontWeight: 700 }}>
                    <IonText color="primary">{userRoleItem.user.name}</IonText>
                  </h2>
                  <h4>
                    <IonText color="medium" style={{ fontWeight: 500 }}>
                      <IonIcon icon={bagOutline}></IonIcon>
                      <small className="ion-margin-start">{userRoleItem.role?.name || "--"}</small>
                    </IonText>
                  </h4>
                  <h4>
                    <IonText color="medium" style={{ fontWeight: 500 }}>
                      <IonIcon icon={locationOutline}></IonIcon>
                      <small className="ion-margin-start">
                        {userRoleItem.location?.name + " (" + userRoleItem.location?.code + ")"}
                      </small>
                    </IonText>
                  </h4>
                </IonLabel>
                {userId != undefined ? null : (
                  <IonButton
                    fill="clear"
                    size="large"
                    color="danger"
                    onClick={() => dispatch(setDeselectUser(userRoleItem))}
                  >
                    <IonIcon icon={trashOutline} />
                  </IonButton>
                )}
              </IonItem>
            ))}
        </IonList>
      )}
    </IonCard>
  );
};
